<template>
<v-card class="mt-3" outlined>
      <v-row no-gutters>
      <v-col cols="10">
      <v-text-field 
      ref="input"
      class="pt-2 pl-2 pr-2 mt-0 pt-0"
      :label="label"
      dense 
      clearable
      v-model="listPartToAdd"
      v-on:keyup.enter="addToList"
      :error-messages="errorMessages"
      >
      </v-text-field>
      </v-col>
      <v-col class="text-center mt-7" cols="2">
        <v-icon @click="addToList" size="25" v-if="!isUpdate" color="primary" >mdi-check</v-icon>
        <v-icon @click="addToList"  size="25" v-else color="primary">mdi-check</v-icon>
        <v-icon v-if="isUpdate"  size="25"  @click="abortUpdate()"  color="red" >mdi-close</v-icon>
      </v-col>
      </v-row>
    <v-list class="pt-0 mt-0 pb-0 mb-0"> 
      <v-list-item dense v-for="(item,index) in filteredItemsList" :key="index">
        {{item}}
        <v-icon dense class="ml-2" v-if="!isUpdate" color='orange' @click="updateOne(item)">mdi-pencil</v-icon>
        <v-icon class="ml-1" dense  v-if="!isUpdate" color="red" @click="deleteOne(item)">mdi-delete</v-icon>
      </v-list-item>
    </v-list>
</v-card>
</template>

<script>
export default {
  data() {
    return {
      listData: [],
      listPartToAdd: '',
      clickedAdd: false,
      disabled: true,
      isUpdate: false,
      updateKey: ''
    }
  },
  computed: {
    filteredItemsList() {
      let filterList = []
      if (this.listData && this.listData.length > 0) {
        for (let item of this.listData) {
          if (item != this.updateKey) filterList.push(item)
        }
      }
      return filterList
    }
  },
  methods: {
    deleteOne(key) {
      let listOfElements = []
      for (let singleData of this.listData) {
        if (singleData != key) {
          listOfElements.push(singleData)
        }
      }
      this.listData = listOfElements
    },
    abortUpdate() {
      this.isUpdate = false
      this.updateKey = ''
      this.listPartToAdd = ''
    },
    updateOne(key) {
      this.listPartToAdd = key
      this.isUpdate = true
      this.updateKey = key
    },
    addToList() {
      if (this.listPartToAdd.length == 0) {
        return
      }
      if (!this.isUpdate) {
        this.listData.push(this.listPartToAdd)
        this.listPartToAdd = ''
      } else {
        this.deleteOne(this.updateKey)
        this.isUpdate = false
        this.updateKey = ''
        this.addToList()
      }
    },
    onAddMoreClick() {
      this.disabled = !this.disabled
      this.$refs.input.focus()
    }
  },
  props: {
    items: Array,
    value: Array,
    label: String,
    errorMessages: Array
  },
  watch: {
    listData: {
      handler() {
        this.$emit('input', this.listData)
      }
    },
    value: {
      handler() {
        if(this.value != undefined && this.value.length != 0) {
          this.listData = this.value
        }
      },
      immediate: true // on first load not populating data
    },
    items: {
      handler() {
        this.listData = this.items
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-list-item {
  height: 25px;
  min-height: 25px;
  font-size: 13px;
}
.v-sheet--outlined {
  border-width: 0.5px;
  border-color: #969696;
}
.v-text-field__details {
  min-height: 0px;
  height: 0px;
}
.v-btn:not(.v-btn--round).v-size--small {
  min-width: 35px;
}
</style>
